export default "__VITE_ASSET__Bu4WFpxH__"